module.exports = __webpack_public_path__ + "img/no-hay-amenities.fef716f8.png";